import {
  DEFAULT_SORT_OPTIONS,
  LOCATION_SORT_OPTIONS,
  SORT_CLOSEST,
  SORT_MOST_POPULAR,
} from "@search/store/constants";
import StringFilter from "@search/store/filters/primitive/StringFilter";

class SortFilter extends StringFilter {
  private _locationMode: boolean;

  constructor(value: string, locationMode: boolean) {
    super({
      name: "sort",
      value,
    });
    this._locationMode = locationMode;
    this._defaultValue = locationMode ? SORT_CLOSEST : SORT_MOST_POPULAR;
  }

  setLocation(locationMode: boolean) {
    const isSet = this.isSet();
    this._locationMode = locationMode;
    this._defaultValue = locationMode ? SORT_CLOSEST : SORT_MOST_POPULAR;

    if (!isSet) {
      this.unset();
    }

    return this.serialize();
  }

  options() {
    if (this._locationMode) {
      return LOCATION_SORT_OPTIONS;
    } else {
      return DEFAULT_SORT_OPTIONS;
    }
  }
}

export default SortFilter;
export { SortFilter };
